import { useEffect } from "react";
import { DashboardTotals } from "@/components/dashboard/DashboardTotals";
import { CompactSmartfile } from "@/components/dashboard/CompactSmartfile";
import { CollapsibleSearchIA } from "@/components/dashboard/CollapsibleSearchIA";
import { RecentPatients } from "@/components/dashboard/RecentPatients";
import { FavoriteApps } from "@/components/dashboard/FavoriteApps";
import { supabase } from "@/integrations/supabase/client";

export default function Dashboard() {
  // Log de acesso ao dashboard
  useEffect(() => {
    const logAccess = async () => {
      try {
        // Verificar se o usuário está autenticado antes de fazer a chamada
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;
        
        await supabase.functions.invoke('log-user-access', {
          body: { action: 'view_dashboard', entity: 'dashboard' }
        });
      } catch (error) {
        console.error('Error logging access:', error);
      }
    };
    logAccess();
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      {/* Meus Aplicativos (Favoritos) - acima do Dashboard */}
      <FavoriteApps />

      {/* Pacientes Recentes em grid horizontal */}
      <RecentPatients />

      {/* Captura Inteligente */}
      <CompactSmartfile />

      {/* Busca Inteligente */}
      <CollapsibleSearchIA inline={true} />

      <h3 className="text-sm font-semibold text-muted-foreground">Dashboard</h3>
      
      {/* Totalizadores no topo */}
      <DashboardTotals />
    </div>
  );
}
